"use strict";

var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "10",
    viewBox: "0 0 11 10"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.47.28c-.44-.33-1.07-.24-1.4.2L3.84 7.4 1.87 5.1c-.35-.42-.98-.47-1.41-.12-.42.36-.47.98-.11 1.4l2.77 3.24c.03.03.06.04.08.06.03.03.05.07.09.09.04.03.08.05.12.07.04.02.07.04.11.05.12.05.24.08.36.08h.01c.13 0 .26-.03.39-.09.04-.01.07-.04.11-.06.04-.03.1-.05.14-.08.04-.03.05-.07.08-.1.02-.03.05-.04.07-.06l5.99-7.92a.98.98 0 0 0-.2-1.38z"
  }));
};